import React from "react";
import Chip from "../Chip";
import MUIGreyColor from "@mui/material/colors/grey";
import MUIAvatar from "@mui/material/Avatar";
import OrderActivityType from "../../Utility/Crud/OrderActivityType";

export default class ChipOrderActivityType extends Chip {
    /**
     * Renders a MUI Avatar.
     */
    renderAvatar() {
        const color = (this.props.orderActivityType ? OrderActivityType.getColor() : MUIGreyColor[500]);
        const avatarColor = this.props.isTransparent ? "transparent" : color;
        const iconColor = this.props.isTransparent ? color : "#fff";

        return (
            <MUIAvatar sx={{ bgcolor: avatarColor }}>
                {OrderActivityType.getIcon({ fontSize: "small", sx: { color: iconColor } })}
            </MUIAvatar>
        );
    }

    /**
     * @return {string} The orderActivityType name.
     */
    getLabel() {
        return this.props.orderActivityType ? OrderActivityType.getDisplayName(this.props.orderActivityType) : "None";
    }
}
